import React from "react";
import SystemGraphs from "./SystemGraphs";

const LatsAndReturns = () => {
  const defaultParameter = 67;

  const pageTitle = "Lats & Returns";

  const endpoints = [
    { label: "15 Minutes", value: "display002-data15-min" },
    { label: "Daily", value: "display002-data-daily" },
  ];

  const parametersEndpoint = "display002-lookup-parameter";

  const mapEndpoint = "display002-map-points";

  return (
    <>
      <SystemGraphs
        defaultParameter={defaultParameter}
        pageTitle={pageTitle}
        endpoints={endpoints}
        parametersEndpoint={parametersEndpoint}
        mapEndpoint={mapEndpoint}
        displayIndex="002"
      />
    </>
  );
};

export default LatsAndReturns;
